import {
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  apiGet,
  apiUploadToGoogleDrive,
  downloadFile,
  uploadFileApi,
} from "./components/api";
import { GrGallery, GrPowerReset } from "react-icons/gr";
import { FaRegFileImage } from "react-icons/fa";
import { MdClear } from "react-icons/md";
import { IoIosCloudDownload } from "react-icons/io";
import FeedBackForm from "./components/FeedBackForm";
import Modal from "./components/Modal";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as ImagineIcon } from "./Logo-Light.svg";
import { IoMdSettings } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import Select from "react-select";
import { mainContext } from "./context/context";
import { useNavigate } from "react-router";
import { Mixpanel, MxEvent } from "./Mixpanel/Mixpanel";
import {
  canvasToBlobAndAppend,
  captureSentryException,
  getBase64FromBlob,
  getCurrentUser,
  getSearch,
  getUserDetails,
  uploadImageToApp,
  validateUser,
} from "./Helpers/helpers";
import Loader from "./components/Loader";
import { IoMdHelpCircleOutline } from "react-icons/io";
import AIVideo from "./assets/ai_video.mp4";
import { IoMdClose, IoMdExpand } from "react-icons/io";
import { ALL_GENERATIONS_URL, BRUSH_TOOL_ROUTE, GET_IMAGE_API_URL, TOOLS } from "./Helpers/constants";
import { MagicToolIcon } from "./assets/icons";
import JoinCommunity from "./components/JoinCommunity";
import { initSentry } from "./config/sentry.config";

const CUSTOM_RESOLUTION = [
  { id: 1, x: 1024, y: 1024, label: "1024 x 1024" },
  { id: 2, x: 1600, y: 1600, label: "1600 x 1600" },
  { id: 3, x: 1024, y: 768, label: "1024 x 768" },
  { id: 4, x: 1080, y: 720, label: "1080 x 720" },
  { id: 5, x: 1280, y: 800, label: "1280 x 800" },
  { id: 6, x: 960, y: 1280, label: "960 x 1280" },
];

var submittedPrompt = "";
var lastToolUsed = TOOLS.inspirationGeneration;
const token = getSearch("token=")

initSentry()

export function App() {
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState(false);
  const [reference, setReference] = useState(false);
  const [referenceBigImage, setReferenceBigImage] = useState({
    show: false,
    width: 500,
  });
  const [finalImage, setFinalImage] = useState(false);
  const [prompt, setPrompt] = useState();
  // const [negativePrompt, setNegativePrompt] = useState(
  //   "CGI, Unreal, Airbrushed, Digital"
  // );
  const [isHarmonized, setIsHarmonized] = useState({});
  const [scale, setScale] = useState(1);
  const positionRef = useRef({ x: 0, y: 0 });
  const [resolution, setResolution] = useState(null);
  const [isDragging, setIsDragging] = useState(true);
  const [showDownloadOption, setShowDownloadOption] = useState();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992); // 500
  const [openSettings, setOpenSettings] = useState(false);
  const [openAdvanceSettings, setOpenAdvanceSettings] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  const [cfg, setCFG] = useState(0.5);
  const [seed, setseed] = useState(0);
  const [freeu, setfreeu] = useState(0);
  const [freeuStrength, setFreeuStrength] = useState({ s1: 0.8, b1: 1.1, s2: 0.4, b2: 1.1 });
  const [pag, setPag] = useState(0);
  const [pagStrength, setPagStrength] = useState(0.5);
  const [adapterStrength, setadapterStrength] = useState(0.5);
  const [strength, setStrength] = useState(0.6);
  const [seedRange, setSeedRange] = useState({ min: 99999999999991, max: 99999999999999999 });
  const [model, setModel] = useState({})
  const [steps, setSteps] = useState(40)
  const [containerStyle, setContainerStyle] = useState({});

  const isGuestUserRef = useRef(null);
  const canvasRef = useRef(null);
  const prevDistance = useRef(0);
  const scaleRef = useRef(1);
  const offsetRef = useRef({ x: 0, y: 0 });
  const scaleInputRef = useRef();
  const isDragRef = useRef(false);
  const mainRef = useRef();
  const imageRef = useRef();
  const initialTransformRef = useRef();
  let lastSavedSettingsRef = useRef({});

  const navigate = useNavigate();

  const { contextData, updateContextData } = useContext(mainContext);

  const SKIP_TEXT = "SKIP_TEXT";
  let aiId = getSearch("ai_id=")

  if (!contextData?.product && !aiId) {
    const token = getSearch("?token=");
    let url = "/";

    if (token) {
      url += "?token=" + token;
      navigate(url);
    }
  }

  const maxHeight = isMobile
    ? window.innerWidth * 0.95
    : window.innerHeight * 0.95;
  const maxWidth = isMobile
    ? window.innerWidth * 0.95
    : (window.innerWidth - window.innerWidth * 0.25) * 0.95;

  useEffect(() => {
    async function setData() {
      setLoading(true)
      const url = `${GET_IMAGE_API_URL}${aiId}/`
      const data = await apiGet(url, true)
      console.log("data", data)

      if (data?.tool_type === TOOLS.bgRemoval) {
        setProduct({
          name: "ProductImage.png",
          url: data?.output_image,
          blobUrl: null
        });

        setTimeout(() => {
          if (imageRef.current) {
            imageRef.current.style.top = 0
            imageRef.current.style.left = 0
            imageRef.current.style.maxWidth = `${mainRef.current.getBoundingClientRect().width}px`
            imageRef.current.style.maxHeight = `${mainRef.current.getBoundingClientRect().height}px`
          }
          aiId = null;
        }, 100)

        setLoading(false)
      }
      else {
        setPrompt(data?.name)
        setseed(data?.seed)

        if (data?.cfg)
          setCFG(data?.cfg)

        if (data?.adapter_strength)
          setadapterStrength(data?.adapter_strength)

        if (data?.reference_image) {
          setReference({
            name: "ReferenceImage.png",
            url: data?.reference_image,
            blobUrl: data?.reference_image,
          })
        }

        if (data?.input_mask_image) {
          setProduct({
            name: "ProductImage.png",
            url: data?.input_mask_image,
            blobUrl: null,
            clearedBackground: true,
          });
          setTimeout(() => {
            if (imageRef.current) {
              imageRef.current.style.top = 0
              imageRef.current.style.left = 0
              imageRef.current.style.maxWidth = `${mainRef.current.getBoundingClientRect().width}px`
              imageRef.current.style.maxHeight = `${mainRef.current.getBoundingClientRect().height}px`
              imageRef.current.style.height = `${mainRef.current.getBoundingClientRect().height}px`
              imageRef.current.style.width = `${mainRef.current.getBoundingClientRect().width}px`
            }
          }, 500)
        }
        else {
          setProduct(SKIP_TEXT);
        }

        if (data?.width && data?.height) {
          console.log(+data?.width, +data?.height)
          const _resolution = CUSTOM_RESOLUTION?.find(_item => _item?.x === +data?.width && _item?.y === +data?.height) || CUSTOM_RESOLUTION[0]
          setResolution(_resolution)
        }

        setTimeout(() => {
          const generateBtn = document.getElementById("generate-button")
          if (generateBtn) generateBtn.click()
        }, 500)
      }
    }

    async function getUserData() {
      if (token) {
        await getUserDetails(token)
      }
      isGuestUserRef.current = (await getCurrentUser())?.isGuestUser
    }

    if (aiId) {
      setData()
    }

    getUserData()

  }, [])

  useEffect(() => {
    if (!finalImage) setIsHarmonized({})
    if (!finalImage && product?.blobUrl)
      updateContextData({ image: product?.blobUrl });
    else if (!finalImage && !product?.blobUrl)
      updateContextData({ image: null });
  }, [finalImage, canvasRef.current, product?.url]);

  const getBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];
      callback("data:image/png;base64," + base64String);
    };
    reader.readAsDataURL(file);
  };

  const getMaxDim = () => {
    const aspectRatio = resolution.x / resolution.y;

    if (isMobile) {
      if (aspectRatio > 1) return { x: maxWidth, y: maxWidth / aspectRatio };
      else {
        const canvasContainer = document.querySelector(".canvas-container");

        return {
          x: aspectRatio * canvasContainer?.getBoundingClientRect()?.height,
          y: canvasContainer?.getBoundingClientRect()?.height,
        };
      }
    }

    if (maxHeight > maxWidth) {
      return { x: maxWidth, y: maxWidth / aspectRatio };
    }

    return { x: maxHeight * aspectRatio, y: maxHeight };
    // else return { x: maxWidth, y: maxWidth / aspectRatio };
  };

  const getChangeInPosition = (container, e) => {
    const event = e.changedTouches?.length ? e.changedTouches?.[0] : e;

    let x = positionRef.current.x + (event.clientX - offsetRef.current.x);
    let y = positionRef.current.y + (event.clientY - offsetRef.current.y);

    offsetRef.current = { x: event.clientX, y: event.clientY };

    return { x: x, y: y };
  };

  const onMouseDown = (e) => {
    // if (isChecked) return;

    const event = e.changedTouches?.length ? e.changedTouches?.[0] : e;
    isDragRef.current = true;
    if (!isMobile) {
      e.preventDefault();
      e.stopPropagation();
    }
    offsetRef.current = { x: event.clientX, y: event.clientY };
    scaleRef.current = scale;
  };

  const onMouseUp = (e) => {
    const event = e.changedTouches?.length ? e.changedTouches?.[0] : e;
    isDragRef.current = false;
    offsetRef.current = { x: event?.clientX, y: event?.clientY };
    setIsDragging(false);
    prevDistance.current = 0;
  };

  const handleDrag = (e) => {
    if (isDragRef.current) {
      e.preventDefault();
      const event = e.changedTouches?.length ? e.changedTouches?.[0] : e;

      if (e?.touches?.length > 1) {
        handlePinch(e);
      } else {
        const container = imageRef.current?.parentNode;

        const { x, y } = getChangeInPosition(container, e);

        positionRef.current = { x: x, y: y };
        setIsDragging(event.clientX + event.clientY);
      }
    }
  };

  const handlePinch = (event) => {
    event.preventDefault();

    const touch1 = event.touches[0];
    const touch2 = event.touches[1];

    if (touch1 && touch2) {
      const distance = Math.sqrt(
        Math.pow(touch2.pageX - touch1.pageX, 2) +
        Math.pow(touch2.pageY - touch1.pageY, 2)
      );

      if (prevDistance.current) {
        const delta =
          (parseFloat(distance) - parseFloat(prevDistance.current)) * 0.0075;
        const newScale = Math.min(
          Math.max(parseFloat(scaleRef.current) + delta, 0.1),
          2
        ).toFixed(1); // Adjust the scale factor as needed

        console.log("Distance : ", delta);
        console.log("SCALE : ", scaleRef.current, newScale);
        if (scaleInputRef?.current) scaleInputRef.current.value = newScale;
        scaleRef.current = newScale;
        setScale(newScale); // Ensure minimum scale is 1
      }

      prevDistance.current = distance;
    }
  };

  const updateContainerStyle = () => {
    const _resolution = resolution || window.canvasResolution;
    const canvasContainer = document.querySelector(".canvas-container");

    const _width =
      canvasContainer?.getBoundingClientRect()?.width || _resolution?.x;
    const _height = (_width * _resolution?.y) / _resolution?.x;

    if (window.innerWidth > 991) {
      setContainerStyle((prev) => ({
        ...prev,
        width: `${_width}px`,
        height: `${_height}px`,
      }));
    } else {
      setContainerStyle({
        width: `${_resolution?.x}px`,
        height: `${_resolution?.y}px`,
      });
    }

    console.log("DEBUG___resolution", {
      ..._resolution,
      _width,
      _height,
      ratio: _resolution?.x / _resolution?.y,
      canvasContainer,
      __width: canvasContainer?.getBoundingClientRect()?.width,
      __height: canvasContainer?.getBoundingClientRect()?.height,
      canvasWidth: window.canvasResolution?.x,
      canvasHeight: window.canvasResolution?.y,
    });
  };

  window.updateContainerStyle = updateContainerStyle;

  useEffect(updateContainerStyle, [resolution]);

  useEffect(() => {
    console.log("DEBUG___containerStyle", {
      ...resolution,
      ...containerStyle,
      wr: window.canvasResolution,
    });
  }, [resolution, containerStyle]);

  useEffect(() => {
    const handleResize = () => {
      updateContainerStyle();

      setIsMobile(window.innerWidth < 992); // 500

      setReferenceBigImage((prev) => ({
        ...prev,
        width:
          prev.width + 50 > window.innerWidth ||
            prev.width + 50 > window.innerHeight
            ? window.innerWidth > window.innerHeight
              ? window.innerHeight - 50
              : window.innerWidth - 50
            : prev.width,
      }));
    };

    setResolution(CUSTOM_RESOLUTION[0]);
    window.canvasResolution = CUSTOM_RESOLUTION[0];

    setProduct(contextData?.product || SKIP_TEXT);

    Mixpanel.track({
      eventName: MxEvent.VISITED_AI_TOOL_PAGE,
    });

    window.addEventListener("mouseup", onMouseUp);
    window.addEventListener("click", () => {
      setShowDownloadOption(false);
      setShowVideo(false);
    });
    window.addEventListener("resize", handleResize);

    validateUser(setPageLoading);

    return () => {
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("click", () => {
        setShowDownloadOption(false);
        setShowVideo(false);
      });
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleImageUpload = (e) => {
    const files = e.target.files;
    const file = files[0];

    if (file && file.type.startsWith("image/")) {
      getBase64(file, (_base64) => {
        setProduct({
          name: file?.name || "ProductImage.png",
          url: _base64,
          blobUrl: URL.createObjectURL(file),
        });
      });
      setFinalImage(null);

      Mixpanel.track({
        eventName: MxEvent.IMAGE_RESET,
        properties: {
          Resolution: `${resolution?.x} x ${resolution?.y}`,
          Prompt: prompt,
          Scale: scale,
          "Product image used": Boolean(product?.url) ? "Yes" : "No",
        },
      });
    }
    document.body.removeChild(e.target);
  };

  const handleAddImage = (isMainImage) => {
    const _file = document.createElement("input");
    _file.accept = "image/*";
    _file.type = "File";
    _file.style.display = "none";
    _file.multiple = false;
    _file.onchange = (e) => handleImageUpload(e, isMainImage);
    document.body.appendChild(_file);
    _file.click();

    Mixpanel.track({
      eventName: MxEvent.CLICKED_CREATE_OR_UPLOAD_PRODUCT,
      properties: {
        Resolution: `${resolution?.x} x ${resolution?.y}`,
        Prompt: prompt,
        Scale: scale,
        "Product image used": Boolean(product?.url) ? "Yes" : "No",
      },
    });
  };

  const handleImageUpload2 = (e) => {
    const files = e.target.files;
    const file = files[0];

    if (file && file.type.startsWith("image/")) {
      getBase64(file, (_base64) => {
        setReference({
          name: file?.name || "ProductImage.png",
          url: _base64,
          blobUrl: URL.createObjectURL(file),
        });

        setCFG(0.5)
        setPagStrength(0.5)
      });
    }
    document.body.removeChild(e.target);
  };

  const handleAddImage2 = (isMainImage) => {
    const _file = document.createElement("input");
    _file.accept = "image/*";
    _file.type = "File";
    _file.style.display = "none";
    _file.multiple = false;
    _file.onchange = (e) => handleImageUpload2(e, isMainImage);
    document.body.appendChild(_file);
    _file.click();
  };

  // const handleRemoveBackground = async () => {
  //   setLoading(true);
  //   // const endpoint = "api/v1/mask/";
  //   const _url = "https://api-bg2.imagine.io/background-remove/";

  //   Mixpanel.track({
  //     eventName: MxEvent.CLICKED_CLEAR_BACKGROUND,
  //     properties: {
  //       Resolution: `${resolution?.x} x ${resolution?.y}`,
  //       Prompt: prompt,
  //       Scale: scale,
  //       "Product image used": Boolean(product?.url) ? "Yes" : "No",
  //     },
  //   });

  //   fetch(product?.url)
  //     .then((response) => response.blob())
  //     .then(async (blob) => {
  //       const formData = new FormData();
  //       formData.append("image", blob);
  //       const _myHeaders = new Headers({ "x-api-key": "admin" });

  //       const _blob = await uploadFileApi(_url, formData, _myHeaders);
  //       getBase64(_blob, (_base64) =>
  //         setProduct({ ...product, url: _base64, clearedBackground: true })
  //       );
  //       setLoading(false);

  //       Mixpanel.track({
  //         eventName: MxEvent.CLEAR_BACKGROUND_SUCCESS,
  //         properties: {
  //           Resolution: `${resolution?.x} x ${resolution?.y}`,
  //           Prompt: prompt,
  //           Scale: scale,
  //           "Product image used": Boolean(product?.url) ? "Yes" : "No",
  //         },
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching Blob:", error);
  //       setLoading(false);

  //       Mixpanel.track({
  //         eventName: MxEvent.CLEAR_BACKGROUND_FAILED,
  //         properties: {
  //           Resolution: `${resolution?.x} x ${resolution?.y}`,
  //           Prompt: prompt,
  //           Scale: scale,
  //           "Product image used": Boolean(product?.url) ? "Yes" : "No",
  //         },
  //       });
  //     });
  // };

  const handleRemoveBackground = async () => {
    setLoading(true);
    // const endpoint = "api/v1/mask/";
    const _url = "https://api-bg.imagine.io/background-remove/";
    // const _url = "https://api-bg-new.imagine.io/background-remove/";

    Mixpanel.track({
      eventName: MxEvent.CLICKED_CLEAR_BACKGROUND,
      properties: {
        Resolution: `${resolution?.x} x ${resolution?.y}`,
        Prompt: prompt,
        Scale: scale,
        "Product image used": Boolean(product?.url) ? "Yes" : "No",
      },
    });

    fetch(product?.url)
      .then((response) => response.blob())
      .then(async (blob) => {
        const formData = new FormData();
        formData.append("image", blob);
        const _myHeaders = new Headers({ "x-api-key": "admin" });

        const _blob = await uploadFileApi(_url, formData, _myHeaders);

        if (!isGuestUserRef.current) {
          // region Upload Image for Main App
          const uploadImageFormData = new FormData()
          uploadImageFormData.append("tool_type", TOOLS.bgRemoval)
          uploadImageFormData.append("input_image_url_key", product?.name)
          uploadImageFormData.append("output_image_url_key", product?.name)
          uploadImageFormData.append("thumb_url_key", "thumbnail.png")
          uploadImageFormData.append("name", product?.name?.split(".")[0])
          uploadImageToApp({ data: uploadImageFormData, input: blob, output: _blob })
          // endregion
        }

        getBase64(_blob, (_base64) => {
          setProduct({ ...product, url: _base64, clearedBackground: true });

          if (!isGuestUserRef.current) {
            apiUploadToGoogleDrive({
              blobFile: _blob,
              base64Image: _base64?.split("base64,")?.[1],
              file_name: "product-image.png",
              category_name: "Background Removal",
            });
          }
        });
        setLoading(false);

        Mixpanel.track({
          eventName: MxEvent.CLEAR_BACKGROUND_SUCCESS,
          properties: {
            Resolution: `${resolution?.x} x ${resolution?.y}`,
            Prompt: prompt,
            Scale: scale,
            "Product image used": Boolean(product?.url) ? "Yes" : "No",
          },
        });
      })
      .catch((error) => {
        captureSentryException({failed_reason : `Error fetching Blob: ${error}`})
        setLoading(false);

        Mixpanel.track({
          eventName: MxEvent.CLEAR_BACKGROUND_FAILED,
          properties: {
            Resolution: `${resolution?.x} x ${resolution?.y}`,
            Prompt: prompt,
            Scale: scale,
            "Product image used": Boolean(product?.url) ? "Yes" : "No",
          },
        });
      });
  };

  const handlePrompt = (e) => {
    e.target.style.height = "auto";
    e.target.style.height = e.target.scrollHeight + "px";
    setPrompt(e.target.value);
  };

  // const handleNegativePrompt = (e) => {
  //   e.target.style.height = "auto";
  //   e.target.style.height = e.target.scrollHeight + "px";
  //   setNegativePrompt(e.target.value);
  // };

  const isSameInspiration = (_seed) => {
      return lastSavedSettingsRef.current?.tool_type === TOOLS.inspirationGeneration &&
      !reference &&
      lastSavedSettingsRef.current?.name === submittedPrompt &&
      lastSavedSettingsRef.current?.width === resolution.x &&
      lastSavedSettingsRef.current?.height === resolution.y &&
      lastSavedSettingsRef.current?.seed === _seed &&
      lastSavedSettingsRef.current?.sample === strength &&
      lastSavedSettingsRef.current?.rotation === cfg &&
      lastSavedSettingsRef.current?.cfg === cfg &&
      lastSavedSettingsRef.current?.adapter_strength === adapterStrength
  }

  const drawImageOnCanvas = (callback, notSkipResolutionRestriction) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = imageRef.current.src;
    // Set up a load event listener for the image
    img.onload = function () {
      // Create a canvas element

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const { top, left, width, height } =
        mainRef.current.getBoundingClientRect();
      const imageTop = imageRef.current.getBoundingClientRect().top;
      const imageLeft = imageRef.current.getBoundingClientRect().left;
      const imageWidth = imageRef.current.getBoundingClientRect().width;
      const imageHeight = imageRef.current.getBoundingClientRect().height;

      let _width = resolution.x;
      let _height = resolution.y;

      if (!notSkipResolutionRestriction && _width > 1024 && _height > 1024) {
        _width = 1024
        _height = 1024
      }

      // Set the canvas dimensions to your custom resolution
      canvas.width = _width;
      canvas.height = _height;

      // Kepp quality of image
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const offsetDimWidth = canvas.width / width;
      const offsetDimHeight = canvas.height / height;

      const offsetY = (imageTop - top) * offsetDimWidth;
      const offsetX = (imageLeft - left) * offsetDimHeight;

      // Draw the image onto the canvas with custom dimensions
      ctx.drawImage(
        img,
        offsetX,
        offsetY,
        imageWidth * offsetDimWidth,
        imageHeight * offsetDimHeight
      );

      callback(canvas);
    };
  };

  async function blobUrlToBlob(blobUrl) {
    // Fetch the Blob from the URL
    const response = await fetch(blobUrl);

    // Ensure the response is successful
    if (!response.ok) {
      captureSentryException({failed_reason :`Failed to fetch the Blob from the URL: ${response.statusText}`})
      throw new Error(
        `Failed to fetch the Blob from the URL: ${response.statusText}`
      );
    }

    // Get the Blob from the response
    const blob = await response.blob();
    return blob;
  }

  const generateImage = async (_seed) => {
    submittedPrompt = prompt;
    const __seed = _seed ? _seed : seed
    Mixpanel.track({
      eventName: MxEvent.CLICKED_GENERATE_IMAGE,
      properties: {
        Resolution: `${resolution?.x} x ${resolution?.y}`,
        Prompt: prompt,
        Scale: scale,
        Seed: __seed,
        "Product image used": Boolean(product?.url) ? "Yes" : "No",
      },
    });

    if (product === SKIP_TEXT) {
      setLoading(true);
      setIsHarmonized({})
      let url = "https://api-adapter.imagine.io/api/v1/reference-adapter/";
      const formData = new FormData();
      formData.append("prompt", prompt?.trim());
      let __blob;

      if (reference?.blobUrl) {
        __blob = await blobUrlToBlob(reference?.blobUrl);
        formData.append("ref_image", __blob);
        formData.append("cfg", 0.5);
      } else {
        // url = "https://techapi.imagine.io/api/v1/text/";
        url = "https://api-gen.imagine.io/text/";
        formData.append("cfg", 0.5);
      }

      // if (negativePrompt) formData.append("negative_prompt", negativePrompt);

      formData.append("seed", __seed);
      formData.append("is_sdxl_product_input", 0);
      formData.append("adapter_strength", adapterStrength);

      let _width = resolution.x;
      let _height = resolution.y;

      if (_width > 1024 && _height > 1024) {
        _width = 1024
        _height = 1024
      }

      formData.append("width", _width);
      formData.append("height", _height);

      const _blob = await uploadFileApi(url, formData);

      let finalBlob = _blob;

      if (resolution.id !== 0 && resolution.x > 1024 && resolution.y > 1024) {
        finalBlob = await resizeImageToDownload(resolution.x, resolution.y, 2, URL.createObjectURL(_blob))
      }

      if (finalBlob) {
        getBase64(finalBlob, async (_base64) => {
          setFinalImage(_base64);
          updateContextData({ image: URL.createObjectURL(finalBlob) });
          // clearDrawingCanvas();

          Mixpanel.track({
            eventName: MxEvent.IMAGE_CREATED_SUCCESS,
            properties: {
              Resolution: `${resolution?.x} x ${resolution?.y}`,
              Prompt: prompt,
              Scale: scale,
              Seed: seed,
              "Product image used": Boolean(product?.url) ? "Yes" : "No",
            },
          });

          // region Upload Image for Main App
          if (!isGuestUserRef.current && !isSameInspiration(__seed)) {
            if (!aiId) {
              const uploadImageFormData = new FormData()
              lastToolUsed = TOOLS.inspirationGeneration
              uploadImageFormData.append("tool_type", TOOLS.inspirationGeneration)
              uploadImageFormData.append("output_image_url_key", `${submittedPrompt || "final-image"}.png`)
              uploadImageFormData.append("thumb_url_key", "thumbnail.png")
              uploadImageFormData.append("name", `${submittedPrompt || "final-image"}`)
              uploadImageFormData.append("width", resolution.x)
              uploadImageFormData.append("height", resolution.y)
              uploadImageFormData.append("seed", __seed)
              uploadImageFormData.append("sample", strength)
              uploadImageFormData.append("rotation", cfg)
              uploadImageFormData.append("cfg", cfg)
              uploadImageFormData.append("adapter_strength", adapterStrength)

              lastSavedSettingsRef.current = {
                tool_type:TOOLS.inspirationGeneration, 
                name:submittedPrompt, 
                width:resolution.x, 
                height:resolution.y, 
                seed:__seed, 
                sample:strength, 
                rotation:cfg, 
                cfg:cfg, 
                adapter_strength:adapterStrength, 
              }

              if (reference?.blobUrl)
                uploadImageFormData.append("reference_image_url_key", reference?.name)

              uploadImageToApp({ data: uploadImageFormData, output: finalBlob, reference: __blob })
            }

            aiId = null
            // endregion

            apiUploadToGoogleDrive({
              blobFile: finalBlob,
              base64Image: _base64?.split("base64,")?.[1],
              file_name: `${submittedPrompt || "final-image"}.png`,
              category_name: "Background Generation",
            });
          }
        });
      }
      setLoading(false);
    } else {
      drawImageOnCanvas((_data) => {
        canvasToBlobAndAppend(_data).then(async (blob) => {
          setLoading(true);
          let url = "https://api-adapter.imagine.io/api/v1/reference-adapter/";
          const formData = new FormData();
          formData.append("prompt", prompt?.trim());

          formData.append("cfg", cfg);
          formData.append("seed", __seed);
          formData.append("is_sdxl_product_input", 1);
          formData.append("adapter_strength", adapterStrength);
          let __blob;
          if (reference?.blobUrl) {
            __blob = await blobUrlToBlob(reference?.blobUrl);
            formData.append("ref_image", __blob);

          } else {
            url = "https://api-gen.imagine.io/inpaint/"
          }

          formData.append("image", blob);
          const _blob = await uploadFileApi(url, formData);
          let finalBlob = _blob;

          if (resolution.id !== 0 && resolution.x > 1024 && resolution.y > 1024) {
            finalBlob = await resizeImageToDownload(resolution.x, resolution.y, 2, URL.createObjectURL(_blob))
          }
          if (finalBlob) {
            getBase64(finalBlob, async (_base64) => {

              // if (resolution.x > 1024 && resolution.y > 1024) {
              //   // Harmonized
              //   drawImageOnCanvas((_data) => {
              //     canvasToBlobAndAppend(_data).then(async (___blob) => {
              //       setIsHarmonized({ ...isHarmonized, status: false, inputImage: URL.createObjectURL(___blob), finalImage: _base64, harmonizedImage: null })
              //     })
              //   }, true)
              // }
              // else {
              //   setIsHarmonized({ ...isHarmonized, status: false, inputImage: URL.createObjectURL(blob), finalImage: _base64, harmonizedImage: null })
              // }

              setFinalImage(_base64);
              updateContextData({ image: URL.createObjectURL(finalBlob) });
              // clearDrawingCanvas();

              Mixpanel.track({
                eventName: MxEvent.IMAGE_CREATED_SUCCESS,
                properties: {
                  Resolution: `${resolution?.x} x ${resolution?.y}`,
                  Prompt: prompt,
                  Scale: scale,
                  Seed: seed,
                  "Product image used": Boolean(product?.url) ? "Yes" : "No",
                },
              });

              // region Upload Image for Main App
              if (!isGuestUserRef.current) {
                if (!aiId) {
                  const uploadImageFormData = new FormData()
                  lastToolUsed = TOOLS.productBackgroundGeneration
                  uploadImageFormData.append("tool_type", TOOLS.productBackgroundGeneration)
                  uploadImageFormData.append("input_image_url_key", product?.name || "input.png")
                  uploadImageFormData.append("input_mask_image_url_key", product?.name || "input.png")
                  uploadImageFormData.append("output_image_url_key", `${submittedPrompt || "final-image"}.png`)
                  uploadImageFormData.append("thumb_url_key", "thumbnail.png")
                  uploadImageFormData.append("name", `${submittedPrompt || "final-image"}`)
                  uploadImageFormData.append("width", resolution.x)
                  uploadImageFormData.append("height", resolution.y)
                  uploadImageFormData.append("seed", __seed)
                  uploadImageFormData.append("sample", strength)
                  uploadImageFormData.append("rotation", cfg)
                  uploadImageFormData.append("cfg", cfg)
                  uploadImageFormData.append("adapter_strength", adapterStrength)
                  if (reference?.blobUrl)
                    uploadImageFormData.append("reference_image_url_key", reference?.name)

                  uploadImageToApp({ data: uploadImageFormData, input: await blobUrlToBlob(product?.blobUrl), output: finalBlob, mask: blob, reference: __blob })
                }
                aiId = null;
                // endregion

                apiUploadToGoogleDrive({
                  blobFile: finalBlob,
                  base64Image: _base64?.split("base64,")?.[1],
                  file_name: `${submittedPrompt || "final-image"}.png`,
                  category_name: "Background Generation",
                });
              }
            });
          }

          setLoading(false);
        });
      });
    }
  };

  const trackScaleChangeMixpanel = (v = 1) => {
    Mixpanel.track({
      eventName: MxEvent.CHANGED_SCALE,
      properties: {
        Resolution: `${resolution?.x} x ${resolution?.y}`,
        Prompt: prompt,
        Scale: scale,
      },
    });
  };

  const handleScaleChange = (e) => {
    const value = e.target.value;

    if (value <= 0.1) {
      setScale(0.1);
      scaleInputRef.current.value = 0.1;
      trackScaleChangeMixpanel(0.1);
    } else if (value >= 2) {
      setScale(2);
      scaleInputRef.current.value = 2;
      trackScaleChangeMixpanel(2);
    } else {
      setScale(value);
      scaleInputRef.current.value = value;
      trackScaleChangeMixpanel(value);
    }
  };

  const changeScale = (e) => {
    const _value = parseFloat(e.target.value);
    if (isNaN(_value)) {
      setScale(1);
      scaleInputRef.current.value = 1;
      trackScaleChangeMixpanel(1);
    } else if (_value <= 0.1) {
      setScale(0.1);
      scaleInputRef.current.value = 0.1;
      trackScaleChangeMixpanel(0.1);
    } else if (_value >= 2) {
      setScale(2);
      scaleInputRef.current.value = 2;
      trackScaleChangeMixpanel(2);
    } else {
      setScale(_value);
      scaleInputRef.current.value = _value;
      trackScaleChangeMixpanel(_value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      changeScale(e);
      e.target.blur();
    }
  };

  const resetTransformation = (changeScaleOnly) => {
    if (!changeScaleOnly) {
      const { height } = mainRef.current.getBoundingClientRect();
      const imageHeight = imageRef.current.getBoundingClientRect().height;

      positionRef.current = {
        x: 0,
        y: height - imageHeight / scale,
      };

      Mixpanel.track({
        eventName: MxEvent.CLICKED_TRANSFORMATION_RESET,
        properties: {
          Resolution: `${resolution?.x} x ${resolution?.y}`,
          Prompt: prompt,
          Scale: 1,
        },
      });
    }

    scaleInputRef.current.value = 1;
    setScale(1);
    if (scale === 1) setIsDragging("Scale changed");
  };

  useEffect(() => {
    if (mainRef?.current && product !== SKIP_TEXT) {
      if (product && !product.clearedBackground && !finalImage) {
        setTimeout(() => {
          const { height } = mainRef.current?.getBoundingClientRect();
          const imageHeight = imageRef.current?.getBoundingClientRect().height;

          if (imageHeight > getMaxDim().y)
            positionRef.current = {
              x: 0,
              y: 0,
            };
          else
            positionRef.current = {
              x: 0,
              y: height - imageHeight / scale,
            };

          initialTransformRef.current = positionRef.current;
          resetTransformation(true);
        }, 20);
      }
    }

    mainRef?.current?.addEventListener("touchmove", handleDrag, {
      passive: false,
    });
    return () => mainRef?.current?.removeEventListener("touchmove", handleDrag);
  }, [product]);

  useEffect(() => {
    if (finalImage) {
      setFinalImage(null);
    }
  }, [scale]);

  const handleChange = (e, isWidth) => {
    const _value = parseInt(e.target.value);

    if (isNaN(_value)) return;

    if (_value >= 4000 || _value < 0) return;

    if (isWidth) {
      setResolution({ ...resolution, x: _value });
    } else setResolution({ ...resolution, y: _value });
  };

  const handleResolutionChange = (value) => {
    setResolution(value);
    window.canvasResolution = value;
    setFinalImage(null);

    Mixpanel.track({
      eventName: MxEvent.CHANGED_RESOLUTION,
      properties: {
        Resolution: value?.label,
        Prompt: prompt,
        Scale: scale,
        "Product image used": Boolean(product?.url) ? "Yes" : "No",
      },
    });

    Mixpanel.track({
      eventName: MxEvent.IMAGE_RESET,
      properties: {
        Resolution: value?.label,
        Prompt: prompt,
        Scale: scale,
        "Product image used": Boolean(product?.url) ? "Yes" : "No",
      },
    });
  };

  const handleDownload = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDownloadOption(!showDownloadOption);

    if (!showDownloadOption) {
      Mixpanel.track({
        eventName: MxEvent.CLICKED_DOWNLOAD,
        properties: {
          Resolution: `${resolution?.x} x ${resolution?.y}`,
          Prompt: prompt,
          Scale: scale,
          "Product image used": Boolean(product?.url) ? "Yes" : "No",
        },
      });
    }
  };

  const resizeImageToDownload = async (width, height, value, _image) => {
    // Create a new promise
    return new Promise(async (resolve, reject) => {
      // Create canvas and context
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Call upscaleImage and wait for the result
      const { image } = await upscaleImage(value, _image);

      const img = new Image();
      img.src = image;

      // Set up a load event listener for the image
      img.onload = async function () {
        // Set the canvas dimensions to your custom resolution
        canvas.width = width;
        canvas.height = height;

        // Keep quality of image
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";

        ctx.drawImage(img, 0, 0, width, height);

        // Convert the canvas to a Blob
        const blob = await canvasToBlobAndAppend(canvas);
        resolve(blob); // Resolve the promise with the blob
        document.body.appendChild(canvas);
        document.body.removeChild(canvas);
      };

      img.onerror = (error) => {
        reject(new Error("Failed to load image"));
        captureSentryException({failed_reason :"Failed to load image"})
      };
    });
  };

  const downloadOriginal = async () => {
    let image = finalImage
    // if (resolution.id !== 0 && resolution.x > 1024 && resolution.y > 1024) {
    //   setLoading(true)
    //   const blob = await resizeImageToDownload(resolution.x, resolution.y, 2, finalImage)
    //   image = URL.createObjectURL(blob)
    //   setLoading(false)
    // }

    downloadFile(
      image,
      product?.name ? `AI ${product.name}` : "AIImage.png"
    );

    Mixpanel.track({
      eventName: MxEvent.DOWNLOAD_STANDARD_IMAGE,
      properties: {
        Resolution: `${resolution?.x} x ${resolution?.y}`,
        Prompt: prompt,
        Scale: scale,
        "Product image used": Boolean(product?.url) ? "Yes" : "No",
      },
    });
  };

  const downloadProductImage = () => {
    downloadFile(product?.url, product?.name);
  };

  const downloadProductOnCanvas = () => {
    drawImageOnCanvas((_data) => {
      canvasToBlobAndAppend(_data).then(async (blob) => {
        downloadFile(
          URL.createObjectURL(blob),
          product?.name ? `mask_${product.name}` : "Mask Image.png"
        );
      });
    });
  };

  const upscaleImage = async (_value, image) => {
    return await fetch(image)
      .then(async (response) => await response.blob())
      .then(async (__blob) => {
        const formData = new FormData();
        formData.append("image", __blob);
        formData.append("value", _value);

        const upscaleUrl = "https://api-enhance.imagine.io/upscaler/"; // bsr-gan
        const _blob = await uploadFileApi(upscaleUrl, formData);
        if (_blob) {
          const imageUrl = URL.createObjectURL(_blob);
          return { image: imageUrl, blob: _blob }
        }
      }).catch(error => {
        captureSentryException({failed_reason : error})
        return {}
      })
  }

  const downloadUpscaledImage = async (_value) => {
    setLoading(true);
    let _blob, _image;
    if (resolution.x > 1024 && resolution.y > 1024) {
      _blob = await resizeImageToDownload(resolution.x * 2, resolution.y * 2, 4, finalImage)
      _image = URL.createObjectURL(_blob)
    }
    else {
      const { image, blob } = await upscaleImage(_value, finalImage)
      _blob = blob
      _image = image
    }

    downloadFile(
      _image,
      product?.name ? `AI ${product.name}` : `AIImage.png`
    );

    Mixpanel.track({
      eventName: MxEvent.DOWNLOAD_UPSCALED_IMAGE,
      properties: {
        Resolution: `${resolution?.x} x ${resolution?.y}`,
        Prompt: prompt,
        Scale: scale,
        "Product image used": Boolean(product?.url) ? "Yes" : "No",
      },
    });

    if (_blob) {
      if (!isGuestUserRef.current) {
        // region Upload Image for Main App
        const uploadImageFormData = new FormData()
        uploadImageFormData.append("tool_type", lastToolUsed)
        uploadImageFormData.append("output_image_url_key", product?.name)
        uploadImageFormData.append("thumb_url_key", "thumbnail.png")
        uploadImageFormData.append("name", prompt)
        uploadImageFormData.append("upscaled", 1)
        uploadImageToApp({ data: uploadImageFormData, output: _blob })

        // endregion
        getBase64(_blob, (_base64) => {
          apiUploadToGoogleDrive({
            blobFile: _blob,
            base64Image: _base64?.split("base64,")?.[1],
            file_name: `${submittedPrompt || "upscaled-image"}.png`,
            category_name: "Upscaled Background Generation",
          });
        });
      }
    }
    setLoading(false);
  };

  function generateRandomNumber(min, max) {
    // Generate a random number between min (inclusive) and max (inclusive)
    const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomNumber;
  }

  const promptControlConponent = () => (
    <div className="prompt-control-parent">
      {isMobile ? (
        <div className="brush-tool-button">{brushComponent()}</div>
      ) : null}
      <div className="title">Prompt</div>
      <div className="prompt">
        <textarea
          type="text-area"
          cols={4}
          rows={4}
          value={prompt}
          onInput={handlePrompt}
          placeholder="Enter your prompt"
          data-hj-allow
        ></textarea>
      </div>

      {/* region Negative Prompt */}
      {/* <div className="negative-prompt">
          <span>Negative prompt</span>
          <div className="toggle-container">
            <label className="toggle">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={toggleSwitch}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        {isChecked ? (
          <div className="negative-prompt-container">
            <textarea
              className="negative-prompt-textarea"
              type="text-area"
              cols={4}
              rows={4}
              value={negativePrompt}
              onInput={handleNegativePrompt}
              placeholder="Add aspects to exclude from background"
            ></textarea>
          </div>
        ) : null} */}
      {/* endregion */}

      <div
        id="generate-button"
        className={`btn generate-btn ${prompt?.trim() ? "" : "disabled"}`}
        onClick={() => generateImage(false)}
      >
        Generate Image
      </div>

      <div
        className="scale-slider-container"
        style={{
          marginBottom: !isMobile ? "1rem" : 0,
          width: "100%",
          display: "flex",
          justifyContent: "center"
        }}
      >
        {/* <div className="scale-info">
          <h5
            style={{
              fontWeight: 500,
              color: "#ffffff",
              paddingRight: "0.5rem",
            }}
          >
            Shuffle
          </h5>
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              width: "80%",
              marginTop: "0.5rem",
            }}
          >
            <input
              type="number"
              value={seed}
              onChange={(e) => {
                setseed(e.target.value || 0);
              }}
              style={{ userSelect: "none", width: "100%" }}
            />
            <GrPowerReset
              style={{
                cursor: "pointer",
                margin: "auto",
                color: "#ffffff",
                fontWeight: "bold",
              }}
              onClick={() => {
                setseed(Math.floor(Math.random() * 1000000));
              }}
            />
          </div>
        </div> */}
        <div
          className={`btn normal-btn ${prompt?.trim() ? "" : "disabled"} ${isMobile ? "full-width" : ""}`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.35rem",
            justifyContent: "center",
          }}
          onClick={() => {
            const _seed = generateRandomNumber(seedRange.min, seedRange.max)
            setseed(_seed)
            if (prompt?.trim())
              generateImage(_seed)
          }}
        >
          <GrPowerReset
            style={{
              cursor: "pointer",
              color: "#ffffff",
              fontWeight: "bold",
            }}
          />
          Shuffle
        </div>

      </div>
      {/* <div className="scale-slider-container">
        <div className="scale-info">
          <h5 style={{ fontWeight: 400 }}>CFG</h5>
          <input
            type="text"
            value={cfgOnly}
            style={{ pointerEvents: "none", userSelect: "none" }}
          />
        </div>

        <input
          type="range"
          step={0.1}
          max={10}
          min={0}
          value={cfgOnly}
          onChange={(e) => setcfgOnly(e.target.value)}
        />
      </div>

      <div className="scale-slider-container">
        <div className="scale-info">
          <h5 style={{ fontWeight: 400 }}>Adapter Strength</h5>
          <input
            type="text"
            value={adapterStrength}
            style={{ pointerEvents: "none", userSelect: "none" }}
          />
        </div>

        <input
          type="range"
          step={0.1}
          max={1}
          min={0}
          value={adapterStrength}
          onChange={(e) => setadapterStrength(e.target.value)}
        />
      </div>

      <div className="upload-product-parent">
        {!reference?.name ? (
          <div className="btn normal-btn" onClick={handleAddImage2}>
            Upload Reference
          </div>
        ) : (
          <div className="product-info">
            <div
              className="btn normal-btn pe name-btn"
              style={{ width: "70%" }}
            >
              {reference.name}
            </div>

            <div style={{ width: "30%" }} className="reset-buttons">
              <div
                className="btn normal-btn btn-hover"
                onClick={handleAddImage2}
              >
                <FaRegFileImage />
              </div>
              <div
                className="btn normal-btn btn-hover"
                onClick={() => setReference(null)}
              >
                <MdClear />
              </div>
            </div>
          </div>
        )}
      </div> */}
    </div>
  );

  const cfgAndAdapterControlConponent = () => (
    <div className="prompt-control-parent">
      {/* {isMobile ? (
        <div className="brush-tool-button">{brushComponent()}</div>
      ) : null}
      <div className="title">Prompt</div>
      <div className="prompt">
        <textarea
          type="text-area"
          cols={4}
          rows={4}
          onInput={handlePrompt}
          placeholder="Enter your prompt"
          data-hj-allow
        ></textarea>
      </div> */}

      {/* region Negative Prompt */}
      {/* <div className="negative-prompt">
          <span>Negative prompt</span>
          <div className="toggle-container">
            <label className="toggle">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={toggleSwitch}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>

        {isChecked ? (
          <div className="negative-prompt-container">
            <textarea
              className="negative-prompt-textarea"
              type="text-area"
              cols={4}
              rows={4}
              value={negativePrompt}
              onInput={handleNegativePrompt}
              placeholder="Add aspects to exclude from background"
            ></textarea>
          </div>
        ) : null} */}
      {/* endregion */}

      {/* <div
        className={`btn generate-btn ${prompt?.trim() ? "" : "disabled"}`}
        onClick={generateImage}
      >
        Generate Image
      </div> */}

      {/* <div
        className="scale-slider-container"
        style={{
          marginBottom: !isMobile ? "1rem" : 0,
          width: isMobile ? "95%" : "80%",
        }}
      >
        <div className="scale-info">
          <h5
            style={{
              fontWeight: 500,
              color: "#ffffff",
              paddingRight: "0.5rem",
            }}
          >
            Shuffle
          </h5>
          <div
            style={{
              display: "flex",
              gap: "0.5rem",
              width: "80%",
              marginTop: "0.5rem",
            }}
          >
            <input
              type="number"
              value={seed}
              onChange={(e) => {
                setseed(e.target.value || 0);
              }}
              style={{ userSelect: "none", width: "100%" }}
            />
            <GrPowerReset
              style={{
                cursor: "pointer",
                margin: "auto",
                color: "#ffffff",
                fontWeight: "bold",
              }}
              onClick={() => {
                setseed(Math.floor(Math.random() * 1000000));
              }}
            />
          </div>
        </div>
      </div> */}

      <div className="scale-slider-wrapper">
        <div
          className={`btn normal-btn advance-settings pb-1`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.open(ALL_GENERATIONS_URL, "_blank")
          }}
        >
          <div className="align-center gap-2">
            <GrGallery style={{width: "1rem", height: "1rem"}}/>My Generations
          </div>
        </div>

        
        <div className="scale-info">
          <h5 style={{ fontWeight: 400 }}>Prompt Guidance</h5>
          <input
            type="text"
            value={cfg}
            style={{ pointerEvents: "none", userSelect: "none" }}
          />
        </div>

        <input
          type="range"
          step={0.1}
          max={1}
          min={0}
          value={cfg}
          onChange={(e) => setCFG(e.target.value)}
        />
      </div>

      <div className="scale-slider-wrapper">
        <div className="scale-info">
          <h5 style={{ fontWeight: 400 }}>Image Influence</h5>
          <input
            type="text"
            value={adapterStrength}
            style={{ pointerEvents: "none", userSelect: "none" }}
          />
        </div>

        <input
          type="range"
          step={0.1}
          max={1}
          min={0}
          value={adapterStrength}
          onChange={(e) => setadapterStrength(e.target.value)}
        />
      </div>

      <div className="upload-product-parent">
        {!reference?.name ? (
          <div className="btn normal-btn" onClick={handleAddImage2}>
            Upload Inspiration Image
          </div>
        ) : (
          <>
            <div className="product-info">
              <div
                className="btn normal-btn pe name-btn"
                style={{ width: "70%" }}
              >
                {reference.name}
              </div>

              <div style={{ width: "30%" }} className="reset-buttons">
                <div
                  className="btn normal-btn btn-hover"
                  onClick={handleAddImage2}
                >
                  <FaRegFileImage />
                </div>
                <div
                  className="btn normal-btn btn-hover"
                  onClick={() => {
                    setCFG(model.value === 1 ? 4 : 0.5)
                    setPagStrength(model.value === 1 ? 3 : 0.5)

                    setReference(null);
                    setReferenceBigImage({
                      show: false,
                      width: 500,
                    });
                  }}
                >
                  <MdClear />
                </div>
              </div>
            </div>
            <div className="reference-img-info">
              <button
                className="reference-image-btn reference-image-expand"
                onClick={() =>
                  setTimeout(
                    () =>
                      setReferenceBigImage((prev) => ({
                        ...prev,
                        show: true,
                      })),
                    100
                  )
                }
              >
                <IoMdExpand />
              </button>
              <img
                className="reference-image"
                src={reference?.blobUrl}
                loading="lazy"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );

  const transformControlComponent = () => (
    <div className="transformation-controls">
      {!isMobile ? (
        <div
          className="resolution"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "117%",
          }}
        >
          {brushComponent()}
        </div>
      ) : null}
      <div className="resolution">
        <h5>Resolution:</h5>
        <Select
          defaultValue={CUSTOM_RESOLUTION[0]}
          value={resolution}
          options={CUSTOM_RESOLUTION}
          onChange={handleResolutionChange}
          isReadOnly
          isSearchable={false}
          className="resolution-select"
          menuPosition="absolute"
          menuPlacement="top"
          styles={{
            control: (provided, state) => ({
              ...provided,
              cursor: "pointer",
            }),
            option: (provided, state) => ({
              ...provided,
              cursor: "pointer",
              color: state.isFocused ? "black" : "inherit",
              backgroundColor: state.isFocused ? "#f0f0f0" : "inherit",
              "&:hover, &:active": {
                color: "#ffffff", // Change font color on hover
                backgroundColor: "#d85c26", // Change background color on hover
              },
            }),
            input: (provided, state) => ({
              ...provided,
              opacity: 0,
            }),
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 4,
            colors: {
              ...theme.colors,
              neutral5: "black",
              primary25: "white",
              primary: "white",
            },
          })}
        />
      </div>

      {product?.url ? (
        <div className="scale-slider" style={{ marginBottom: "2rem" }}>
          <div className="scale-slider-container">
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <div className="scale-info" style={{ width: "90%" }}>
                <h5> Scale</h5>
                <input
                  ref={scaleInputRef}
                  type="text"
                  onKeyDown={handleKeyDown}
                  onBlur={changeScale}
                  defaultValue={1}
                  data-hj-allow
                />
              </div>
              <div
                className="footer"
                style={{
                  width: "10%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "1.25rem",
                }}
                onClick={() => resetTransformation(false)}
              >
                <span>
                  <GrPowerReset />
                </span>
              </div>
            </div>

            <input
              type="range"
              step={0.1}
              max={2}
              min={0.1}
              value={scale}
              onChange={handleScaleChange}
              data-hj-allow
            />
          </div>
        </div>
      ) : // </div>
        null}
    </div>
  );

  const clearProductComponent = () =>
    product?.url ? (
      <div
        className={`btn normal-btn clear-background ${finalImage ? "disabled" : ""
          }`}
        onClick={handleRemoveBackground}
      >
        Clear background
      </div>
    ) : null;

  const brushComponent = () => (
    <div
      className="btn normal-btn"
      style={{
        width: "100% !important",
        display: "flex",
        alignItems: "center",
        gap: "0.35rem",
        justifyContent: "center",
      }}
      onClick={() => {
        const fileUrl = contextData?.image ? `?file=${contextData?.image}` : "";
        window.open(window.location.origin + BRUSH_TOOL_ROUTE + fileUrl);
      }}
    >
      <MagicToolIcon /> Magic Tool
    </div>
  );

  const uploadProductComponent = () => (
    <div className="upload-product-parent">
      {!product?.name ? (
        <div className="btn normal-btn" onClick={handleAddImage}>
          Upload Product
        </div>
      ) : (
        <div className="product-info">
          <div className="btn normal-btn pe name-btn" style={{ width: "70%" }}>
            {product.name}
          </div>

          <div style={{ width: "30%" }} className="reset-buttons">
            <div className="btn normal-btn btn-hover" onClick={handleAddImage}>
              <FaRegFileImage />
            </div>
            <div
              className="btn normal-btn btn-hover"
              onClick={() => setProduct(SKIP_TEXT)}
            >
              <MdClear />
            </div>
          </div>
        </div>
      )}
    </div>
  );

  useEffect(() => {
    setseed(generateRandomNumber(seedRange.min, seedRange.max))
  }, [seedRange])


  const handleHarmoinzeImage = async () => {
    setLoading(true)
    if (isHarmonized?.harmonizedImage) {
      if (isHarmonized?.status) {
        setFinalImage(isHarmonized?.finalImage)
      }
      else {
        setFinalImage(isHarmonized?.harmonizedImage)
      }
      setIsHarmonized({ ...isHarmonized, status: !isHarmonized?.status })
    }
    else {
      // const maskedImage = await convertTransparentToBlackAndNonTransparentToWhite(isHarmonized?.inputImage)
      const url = "https://api-harmony.imagine.io/api/v1/harmony/"

      const [compositeImageBase64, transparentImageBase64] = await Promise.all([
        getBase64FromBlob(await blobUrlToBlob(isHarmonized?.finalImage)),
        getBase64FromBlob(await blobUrlToBlob(isHarmonized?.inputImage))
      ]);

      // Prepare FormData
      const payload = {
        composite_image: compositeImageBase64,
        transparent_image: transparentImageBase64,
      }
      const response = await fetch(url, { method: "POST", body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } })
      const _harmonizedImage = await response.json()

      if (_harmonizedImage?.status_code === 200)
        setIsHarmonized({ ...isHarmonized, status: !isHarmonized?.status, harmonizedImage: "data:image/png;base64," + _harmonizedImage?.output })
      setFinalImage("data:image/png;base64," + _harmonizedImage?.output)
    }
    setLoading(false)
  }

  const advanceSettings = () => {
    const options = [
      { value: 0, label: 'Standard' },
      { value: 1, label: 'HD' },
      // { value: 2, label: 'JUGGER' }
    ];

    const customStyles = {
      control: (provided) => ({
        ...provided,
        color: '#333',
        padding: '5px',
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#d85c26' : '#fff',
        color: state.isSelected ? '#fff' : '#333',
        padding: 10,
      }),
      singleValue: (provided) => ({
        ...provided,
        color: '#000000',
      }),
    };
    return (
      <>
        <div
          className="scale-slider"
          style={{ width: "100%" }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="scale-slider-container pb-1 ">
            <div className="scale-info">
              <h5 style={{ fontWeight: 400 }}>CFG</h5>
              <input
                type="text"
                value={cfg}
                style={{ pointerEvents: "none", userSelect: "none" }}
              />
            </div>

            <input
              type="range"
              step={0.1}
              max={reference ? 1 : 10}
              min={0}
              value={cfg}
              onChange={(e) => setCFG(e.target.value)}
            />
          </div>

          {/* <div
            className="scale-slider pb-1 "
            style={{ width: "100%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="scale-slider-container">
              <div className="scale-info">
                <h5 style={{ fontWeight: 400 }}>Denoising strength</h5>
                <input
                  type="text"
                  value={strength}
                  style={{ pointerEvents: "none", userSelect: "none" }}
                />
              </div>

              <input
                type="range"
                step={0.1}
                max={1}
                min={0.1}
                value={strength}
                onChange={(e) => {
                  setStrength(e.target.value);
                }}
              />
            </div>
          </div> */}

          <div
            className="scale-slider pb-1 "
            style={{ width: "100%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="scale-slider-container">
              <div className="scale-info">
                <h5 style={{ fontWeight: 400 }}>Adapter Strength</h5>
                <input
                  type="text"
                  value={adapterStrength}
                  style={{ pointerEvents: "none", userSelect: "none" }}
                />
              </div>

              <input
                type="range"
                step={0.1}
                max={1}
                min={0.1}
                value={adapterStrength}
                onChange={(e) => {
                  setadapterStrength(e.target.value);
                }}
              />
            </div>
          </div>

          {/* Steps */}
          {model?.value ? <div className="scale-slider-container pb-1 ">
            <div className="scale-info">
              <h5 style={{ fontWeight: 400 }}>Steps</h5>
              <input
                type="text"
                value={steps}
                style={{ pointerEvents: "none", userSelect: "none" }}
              />
            </div>

            <input
              type="range"
              step={1}
              max={100}
              min={1}
              value={steps}
              onChange={(e) => setSteps(e.target.value)}
            />
          </div> : null}

          {/* Seed Range */}
          <div className="scale-slider-container">
            <div className="scale-info">
              <div className="align-center flex-column full-width">
                {/* <h5 style={{ fontWeight: 400 }}>Seed Range : </h5> */}
                <input
                  className="full-width"
                  type="number"
                  value={seedRange.min}
                  onChange={(e) => {
                    const _value = e.target.value
                    // if (_value > 0 && _value < 50 && _value < seedRange.max)
                    setSeedRange({ ...seedRange, min: parseInt(_value) })
                  }}
                // style={{ pointerEvents: "none", userSelect: "none" }}
                />
                <input
                  className="full-width"
                  type="number"
                  value={seedRange.max}
                  // style={{ pointerEvents: "none", userSelect: "none" }}
                  onChange={(e) => {
                    const _value = e.target.value
                    // if (_value > 0 && _value < 50 && _value > seedRange.min)
                    setSeedRange({ ...seedRange, max: parseInt(_value) })
                  }}
                />
              </div>
            </div>
          </div>

          {/* Pag */}
          <div className="negative-prompt">
            <span>Pag</span>
            <div className="toggle-container">
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={!!pag}
                  onChange={() =>
                    setPag(pag ? 0 : 1)
                  }
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>

          {/* Pag strength */}
          {pag ? <div className="scale-slider-container pt-1 ">
            <div className="scale-info">
              <h5 style={{ fontWeight: 400 }}></h5>
              <input
                type="text"
                value={pagStrength}
                style={{ pointerEvents: "none", userSelect: "none" }}
              />
            </div>

            <input
              type="range"
              step={0.1}
              max={10}
              min={0.1}
              value={pagStrength}
              onChange={(e) => setPagStrength(e.target.value)}
            />
          </div> : null}

          {/* Freeu */}
          <div className="negative-prompt">
            <span>Freeu</span>
            <div className="toggle-container">
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={freeu}
                  onChange={() => setfreeu(freeu ? 0 : 1)}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>

          {/* freeu strength */}
          {freeu ?
            <>
              <div className="scale-slider-container pt-1 ">
                <div className="scale-info">
                  <h5 style={{ fontWeight: 400 }}>S1</h5>
                  <input
                    type="text"
                    value={freeuStrength?.s1}
                    style={{ pointerEvents: "none", userSelect: "none" }}
                  />
                </div>

                <input
                  type="range"
                  step={0.1}
                  max={10}
                  min={0.1}
                  value={freeuStrength?.s1}
                  onChange={(e) => setFreeuStrength({ ...freeuStrength, s1: e.target.value })}
                />
              </div>

              <div className="scale-slider-container pt-1 ">
                <div className="scale-info">
                  <h5 style={{ fontWeight: 400 }}>S2</h5>
                  <input
                    type="text"
                    value={freeuStrength?.s2}
                    style={{ pointerEvents: "none", userSelect: "none" }}
                  />
                </div>

                <input
                  type="range"
                  step={0.1}
                  max={10}
                  min={0.1}
                  value={freeuStrength?.s2}
                  onChange={(e) => setFreeuStrength({ ...freeuStrength, s2: e.target.value })}
                />
              </div>

              <div className="scale-slider-container pt-1 ">
                <div className="scale-info">
                  <h5 style={{ fontWeight: 400 }}>B1</h5>
                  <input
                    type="text"
                    value={freeuStrength?.b1}
                    style={{ pointerEvents: "none", userSelect: "none" }}
                  />
                </div>

                <input
                  type="range"
                  step={0.1}
                  max={10}
                  min={0.1}
                  value={freeuStrength?.b1}
                  onChange={(e) => setFreeuStrength({ ...freeuStrength, b1: e.target.value })}
                />
              </div>

              <div className="scale-slider-container pt-1 ">
                <div className="scale-info">
                  <h5 style={{ fontWeight: 400 }}>B2</h5>
                  <input
                    type="text"
                    value={freeuStrength?.b2}
                    style={{ pointerEvents: "none", userSelect: "none" }}
                  />
                </div>

                <input
                  type="range"
                  step={0.1}
                  max={10}
                  min={0.1}
                  value={freeuStrength?.b2}
                  onChange={(e) => setFreeuStrength({ ...freeuStrength, b2: e.target.value })}
                />
              </div>
            </>
            : null}


          {/* Model */}
          <div style={{ width: '100%', margin: '0.5rem auto' }}>
            <Select
              options={options}
              defaultValue={options[0]}
              onChange={(value) => {
                setCFG(value?.value === 1 ? 4 : value?.value === 2 ? 2 : 0.5)
                setSteps(value?.value === 1 ? 40 : value?.value === 2 ? 5 : steps)
                setPagStrength(value?.value === 1 ? 3 : value?.value === 2 ? 0.5 : 0.5)
                setModel(value)
              }}
              placeholder="Select a model"
              styles={customStyles}
              isSearchable
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {referenceBigImage?.show && reference?.blobUrl ? (
        <div
          className="reference-image-container"
          style={{
            width: `${referenceBigImage?.width}px`,
            height: `${referenceBigImage?.width}px`,
          }}
        >
          <div className="reference-image-container-inner">
            <img
              src={reference?.blobUrl}
              alt={reference?.name}
              className="reference-image-big"
              loading="lazy"
            />
            <div className="reference-image-actions">
              <button
                className="reference-image-btn"
                disabled={referenceBigImage?.width - 100 < 250}
                onClick={() =>
                  setReferenceBigImage((prev) => ({
                    ...prev,
                    width:
                      prev.width - 100 < 250 ? prev.width : prev.width - 100,
                  }))
                }
              >
                -
              </button>
              <button
                className="reference-image-btn"
                disabled={referenceBigImage?.width > window.innerHeight - 100}
                onClick={() =>
                  setReferenceBigImage((prev) => ({
                    ...prev,
                    width:
                      prev.width > window.innerWidth - 100 ||
                        prev.width > window.innerHeight - 100
                        ? prev.width
                        : prev.width + 100,
                  }))
                }
              >
                +
              </button>
              <button
                className="reference-image-btn"
                onClick={() =>
                  setReferenceBigImage((prev) => ({ ...prev, show: false }))
                }
              >
                <MdClear />
              </button>
            </div>
          </div>
        </div>
      ) : null}
      <Loader loading={pageLoading} backgroundColor="#fff" />
      <div className="App">
        {product ? (
          <>
            <div className="logo-header">
              <a href="https://imagine.io/">
                <ImagineIcon className={`logo`} />
              </a>
              <div
                className="help"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowVideo(true);
                }}
              >
                <IoMdHelpCircleOutline />
                <div className="tooltip">Help</div>
              </div>
            </div>
            <>
              <div className="container">
                {openAdvanceSettings ? <div
                  className={`advance-settings-options ${openAdvanceSettings
                    ? "openAdvanceSettings"
                    : "close-advance-settings"
                    }`}
                >
                  <div className="header">
                    <div className="text-bold">Advance Settings</div>
                  </div>
                  <div className="body">{advanceSettings()}</div>
                </div> : null}
                {!isMobile ? (
                  <div className="sidebar sidebar-left">
                    {/* {product?.url || isChecked ? (
                      <>
                        <div
                          className={`advance-settings ${
                            openAdvanceSettings ? "advance-settings-opened" : ""
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setOpenAdvanceSettings(!openAdvanceSettings);
                          }}
                        >
                          <IoMdSettings />
                        </div>

                        <div
                          className={`advance-settings-options ${
                            openAdvanceSettings
                              ? "openAdvanceSettings"
                              : "close-advance-settings"
                          }`}
                        >
                          <div className="header">
                            <div>Advance Settings</div>
                          </div>
                          <div className="body">{advanceSettings()}</div>
                        </div>
                      </>
                    ) : null} */}
                    <div className="w-100 align-center flex-column ">
                      {uploadProductComponent()}
                      {clearProductComponent()}
                      {promptControlConponent()}
                    </div>
                    <div className="w-100 align-center ">
                      {transformControlComponent()}
                    </div>

                  </div>
                ) : (
                  <></>
                )}

                {isMobile && product?.url ? uploadProductComponent() : null}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    width: "calc(100% - 632px)",
                  }}
                  className="canvas-container"
                >
                  <div
                    style={{
                      // height: `${resolution.y}px`,
                      // width: `${resolution.x}px`,
                      position: "relative",
                      userSelect: "none",
                      overflow: "hidden",
                      boxShadow: isMobile ? "" : "rgb(0 0 0) 4px 0px 15px 1px",
                      maxWidth: getMaxDim().x ? `${getMaxDim().x}px` : "100%",
                      maxHeight: getMaxDim().y ? `${getMaxDim().y}px` : "100%",
                      ...containerStyle,
                    }}
                    className="image-container"
                    ref={mainRef}
                    onMouseMove={handleDrag}
                    // onTouchMove={handleDrag}
                    onTouchStart={onMouseDown}
                    onMouseDown={onMouseDown}
                    onTouchEnd={onMouseUp}
                  >
                    <div></div>
                    <div className="finalImage-btns">
                      <div
                        className={`btn btn-hover normal-btn position-relative ${finalImage || product?.url ? "" : "hidden"
                          }`}
                        // onClick={downloadOriginal}
                        onClick={
                          finalImage ? handleDownload : downloadProductImage
                        }
                      >
                        <IoIosCloudDownload />
                        <div
                          className={`download-options ${showDownloadOption ? "show-download-options" : ""
                            }`}
                        >
                          <div
                            className="download-options-item"
                            onClick={downloadOriginal}
                          >
                            Standard
                          </div>

                          <div className="separator"></div>
                          <div
                            className="download-options-item"
                            onClick={() => downloadUpscaledImage(2)}
                          >
                            High Resolution
                          </div>

                          {/* <div className="separator"></div>
                          <div
                            className="download-options-item"
                            onClick={() => downloadUpscaledImage(4)}
                          >
                            Upscale 4X
                          </div> */}
                        </div>
                      </div>
                      <div
                        className={`btn btn-hover normal-btn ${finalImage ? "" : "hidden"
                          }`}
                        onClick={() => {
                          setFinalImage(null);

                          Mixpanel.track({
                            eventName: MxEvent.CLICKED_IMAGE_RESET,
                            properties: {
                              Resolution: `${resolution?.x} x ${resolution?.y}`,
                              Prompt: prompt,
                              Scale: scale,
                              "Product image used": Boolean(product?.url)
                                ? "Yes"
                                : "No",
                            },
                          });

                          Mixpanel.track({
                            eventName: MxEvent.IMAGE_RESET,
                            properties: {
                              Resolution: `${resolution?.x} x ${resolution?.y}`,
                              Prompt: prompt,
                              Scale: scale,
                              "Product image used": Boolean(product?.url)
                                ? "Yes"
                                : "No",
                            },
                          });
                        }}
                      >
                        <MdClear />
                      </div>
                    </div>
                    {/* Remove IT */}
                    {/* <div
                      className={`btn btn-hover normal-btn position-relative temp ${
                        product?.url ? "" : "hidden"
                      }`}
                      onClick={downloadProductOnCanvas}
                      style={{
                        background:
                          "linear-gradient(135deg, rgb(255 109 45), rgb(76 23 0))",
                        left: "1rem",
                        top: "1rem",
                        border: "none",
                      }}
                    >
                      <IoIosCloudDownload />
                    </div> */}
                    {/* Remove IT */}
                    {product !== SKIP_TEXT ? (
                      <img
                        ref={imageRef}
                        src={product?.url}
                        className="img"
                        alt=""
                        style={{
                          maxWidth: `${getMaxDim().x > resolution.x
                            ? resolution.x
                            : getMaxDim().x
                            }px`,
                          maxHeight: `${getMaxDim().y > resolution.y
                            ? resolution.y
                            : getMaxDim().y
                            }px`,
                          position: "relative",
                          top: `${positionRef.current.y}px`,
                          left: `${positionRef.current.x}px`,
                          objectFit: "contain",
                          userSelect: "none",
                          display: "block",
                          cursor: `${!isDragRef.current ? "grab" : "grabbing"}`,
                          transition: "transform 0.1s linear",
                          transform: `scale(${scale})`,
                        }}
                      />
                    ) : null}

                    {finalImage ? (
                      <img
                        src={finalImage}
                        className="img"
                        alt=""
                        style={{
                          // height: `${resolution.y}px`,
                          // width: `${resolution.x}px`,
                          maxWidth: `${getMaxDim().x}px`,
                          maxHeight: `${getMaxDim().y}px`,
                          position: "absolute",
                          top: `0px`,
                          left: `0px`,
                          objectFit: "contain",
                          userSelect: "none",
                          display: "block",
                          transition: "transform 0.1s ease-in-out",
                          cursor: "default",
                          ...containerStyle,
                        }}
                      />
                    ) : null}
                  </div>
                </div>

                {isMobile ? (
                  <>
                    <div className="advance-settings-conatiner">
                      {!product?.url
                        ? uploadProductComponent()
                        : clearProductComponent()}
                      <>
                        <div
                          className={`settings normal-btn `}
                          onClick={() => setOpenSettings(!openSettings)}
                        >
                          <IoMdSettings
                            className={openSettings ? "settings-opened" : ""}
                          />
                        </div>

                        <div
                          className={`settings-options ${openSettings ? "openSettings" : "close-settings"
                            }`}
                        >
                          <div className="header">
                            <div>Settings</div>
                            <RxCross2 onClick={() => setOpenSettings(false)} />
                          </div>
                          <div className="body">
                            {transformControlComponent()}
                          </div>
                        </div>
                      </>
                    </div>
                    {promptControlConponent()}
                    {cfgAndAdapterControlConponent()}
                  </>
                ) : (
                  <></>
                )}

                {!isMobile ? (
                  <div className="sidebar sidebar-right">
                    {/* {uploadProductComponent()} */}
                    {/* {clearProductComponent()} */}
                    {/* {promptControlConponent()} */}
                    {cfgAndAdapterControlConponent()}
                    {/* {transformControlComponent()} */}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </>
            <Loader loading={loading} />
            <div
              className={`feedback-footer  ${product && !isMobile ? "small" : ""
                }`}
            >
              {/* <div>This feature is still in alpha.</div> */}
              <div
                className="feedback"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  updateContextData({ showModal: true });
                }}
              >
                Give us your Feedback
              </div>
              {isMobile ? "|": ""}
              {JoinCommunity()}
            </div>
            {/* Feedback Form */}
            <Modal
              isOpen={contextData.showModal}
              onClose={() => updateContextData({ showModal: false })}
              title="Feedback"
            >
              <FeedBackForm />
            </Modal>
          </>
        ) : null}

        {showVideo ? (
          <div className="ai-video-player">
            <div
              className="video-container"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <video
                id="ai-video-player"
                loop
                controls
                autoPlay
                playsInline
                controlsList="nodownload"
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
              >
                <source src={AIVideo} type="video/mp4" />
              </video>
              <div className="closeIcon" onClick={() => setShowVideo(false)}>
                <IoMdClose />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
